<rt-input-attributes
  [selectedAttributes]="selectedAttributes"
  [filteredAttributes]="filteredAttributes"
  [placeholder]="'rtu.ui.select.none' | translate"
  [translationsContext]="$any('rtiSimpleMultiselect')"
  (save)="attributeAdded($event)"
  (deleteAttribute)="attributeDeleted($event)"
  (clearAll)="clearAttributes()"
  (query)="attributeQueried($event)"
/>
